import { QueryFunction } from '@tanstack/react-query';

import { handleErrors } from '@/shared/lib/errors';

import { apiWrapper } from '@/shared/api/main';

import { IErrorResponseData } from '@/shared/types/error';

import { IMenuCountersResponse } from '@/entities/menu-counters/model/types/menuCounters';

/**
 * Получение агрегирующих счётчиков навигационного меню
 * @param root0 - параметры запроса
 * @param root0.queryKey - массив, первый элемент — URL запроса
 */
export const getMenuCounters: QueryFunction<IMenuCountersResponse> = async ({
  queryKey
}) => {
  const queryUrl = queryKey[0] as string;

  const response = await apiWrapper.get<
    IMenuCountersResponse,
    IErrorResponseData
  >(queryUrl);

  if (!response.ok) {
    const { mainError } = handleErrors(response);

    throw new Error(mainError);
  }

  return response.data || ({} as IMenuCountersResponse);
};
